module.exports = __webpack_public_path__ + "static/media/user-tie.d54aa6e0.svg";